import {ArticleFaq} from '@strapi/types/Articles';


import FaqItem from './FaqItem';
import styles from './ArticleFaq.module.scss';
import {FAQ_ANCHOR_ID} from "@utils/articles/tableOfContents";

export default function ArticleFaq({faq}: {faq: ArticleFaq}) {
  if (!faq.items?.length) {
    return null;
  }

  return (
    <>
      <h2 className={styles.title} id={FAQ_ANCHOR_ID}>
        {faq.title}
      </h2>
      <div
        className={styles.contentContainer}
        itemScope
        itemType="https://schema.org/FAQPage"
      >
        {faq.items.map((item, index) => (
          <FaqItem key={index} item={item} />
        ))}
      </div>
    </>
  );
}
